$.fn.chat = function (options) {
  	'use strict';

  	var _elem = $(this),  // instance to $('#selector')
      	_this = this,     // instance to this plugin
        _form = _elem.find('form'),
        _idleInterval = 0,
        _refreshInterval = 0,
        _idleTime = 0;

  	// custom variables
  	var o = $.extend({
        checkNewMessagesInterval: 5000 // 10 seconds
  	}, options);

  	_this.init = function()
    {
        // check wether user is idle or not
        _idleInterval = setInterval(function() {
            _idleTime++;
            if (_idleTime > 4)
            {
                clearInterval(_refreshInterval);
                clearInterval(_idleInterval);

                _this.showIdleMessage();
            }
        }, 60000); // 1 minute

        // if mouse is moved reset idle time
        $(document).mousemove(function() {
            _idleTime = 0;
        });

        // if key is pressed, reset idletime
        $(document).keypress(function() {
            _idleTime = 0;
        });

        // check every X seconds for new messages
        _refreshInterval = setInterval(function() {
            _this.checkNewMessages();
        }, o.checkNewMessagesInterval);

        // automatically scroll to bottom on page load
        _this.updateScroll();

        // submit button sends message aswell
        _elem.find('form').on('submit', function(e) {
            e.preventDefault();
            _this.submitMessage();
        });

        // check if enter has been pressed to hide / show label
        $('div[contenteditable]').keydown(function(e) {
            // trap the return key being presed
            if (e.keyCode === 13)
            {
                e.preventDefault();
                _this.submitMessage();
            }
        }).keyup(function(e) {
            var html = $(this).html();

            if (html.length === 0)
                _this.showLabel();
            else
                _this.hideLabel();
        });
  	};

  	_this.showIdleMessage = function() {
        $('#idle').slideDown(500);
    };

  	// show 'type a message' label
  	_this.showLabel = function() {
        _elem.find('.input-placeholder').show();
    };

    // hide 'type a message' label
    _this.hideLabel = function() {
        _elem.find('.input-placeholder').hide();
    };

    _this.checkNewMessages = function() {
        var id = $('#chatbox').data('car-id');

        $.ajax('/customer-login/', { data: {ajax: 1, checkNewMessages: 1, carid: id},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var response = jQuery.parseJSON(data);


                if (response.newMessages == '1')
                {
                    _this.appendHTML(response.messages);
                    _this.updateScroll();
                }
            }
        });
    };

    // submit message through ajax call
  	_this.submitMessage = function() {
        var id = $('#chatbox').data('car-id');

        var message = _elem.find('.input-message').html();

        $.ajax('/customer-login/', { data: {ajax: 1, submitMessage: 1, message: message, carid: id},
            type: 'POST',
            error: function(data) {
                console.log(data);
            },
            success: function(data) {
                var response = jQuery.parseJSON(data);

                // success
                if (response.success == '1')
                {
                    var timestamp = response.timestamp;

                    _this.appendMessage(timestamp);
                    _this.clearInput();
                    _this.updateScroll();
                }
                // error !
                else
                {
                    _this.clearInput();
                    _this.updateScroll();
                }
            }
        });
    };

    _this.appendHTML = function(messageHTML) {
        console.log(messageHTML);
        _elem.find('.messages').append(messageHTML);
    };

    // append message to chatbox
    _this.appendMessage = function(timestamp) {
        var message = _elem.find('.input-message').html();

        // html template to add when succesvfull
        var html = ['<div class="message self">',
                            '<div class="inner-message">',
                                '<p>'+message+'</p>',
                                '<span class="timestamp">'+timestamp+'</span>',
                            '</div>',
                        '</div>'

        ].join("\n");

        _elem.find('.messages').append(html);
    };

    // clear input field after submit has been done
    _this.clearInput = function() {
        _elem.find('.input-message').html('');
    };

    // update scroll to bottom of div
    _this.updateScroll = function() {
        var chatbox = _elem.find('.messages');
        chatbox.scrollTop(chatbox.prop('scrollHeight'));
    };

  	_this.init();
};